export class CustomRegisterCategory {
	crCategoriesId: number;
	customRegisterId: number;
	categoryId: number;
	categoryName: string;
	categoryImage: string;
	order: number;
	rowNumberUp: number;
	rowNumberDown: number;
	rowNumber: number;
	selected: boolean;
}
